const NAME = 'MEMBERSHIP';

export const memberTypesList = (store) => store[NAME].getTypes.data || [];
export const memberTiersList = (store) => store[NAME].getTiers.data || [];
export const memberTier = (store) => store[NAME].getTier.data || {};
